import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { Store } from '@ngrx/store';
import { AppState } from './reducers';
import { Subscription } from 'rxjs';
import { NavigatorBsResChanged } from './store/navigator/navigator.actions';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BreakpointService, BreakpointSelected } from './shared/breakpointService';

declare let gtag: Function;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

	private breakpointsSubscription: Subscription;

	@ViewChild(HeaderComponent, { static: true })
	header: HeaderComponent;


	constructor( private store: Store<AppState>, private breakpointService: BreakpointService, router: Router ) {
		router.events.subscribe( event => {
			if( event instanceof NavigationEnd )
				gtag( 'config', environment.googleAnalyticsTrackingId, { 'page_path': event.urlAfterRedirects } );
		});
	}

	ngOnInit(): void {
		this.breakpointsSubscription = this.breakpointService.selected().subscribe( ( event: BreakpointSelected ) => {
			console.log( 'actualBsRes: ' + event.name );
			this.store.dispatch( new NavigatorBsResChanged( { bsRes: event.name } ) );
		});
	}

	ngOnDestroy(): void {
		this.breakpointsSubscription?.unsubscribe();
	}

	onMiniMenuClosed() {
		this.header.miniMenuClosed();
	}

}
